// extracted by mini-css-extract-plugin
module.exports = {"section":"_payment-Section-module--section--18pvc"};